import React from 'react';
import { Footer } from '../components/Footer';

export function Demo() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-6 py-16">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">体验 MemPalace</h1>
          <p className="text-lg text-gray-600">
            这里是一个简单的演示，展示了 MemPalace 的基本功能。
          </p>
        </div>

        {/* 模拟的记忆图谱 */}
        <div className="bg-gray-50 rounded-lg p-8 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">记忆图谱演示</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <h3 className="font-medium text-gray-900 mb-2">学习笔记</h3>
              <p className="text-sm text-gray-600">编程、数据库、网络技术</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <h3 className="font-medium text-gray-900 mb-2">项目经验</h3>
              <p className="text-sm text-gray-600">开发过程、遇到的问题</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <h3 className="font-medium text-gray-900 mb-2">灵感收集</h3>
              <p className="text-sm text-gray-600">零散的想法和创意</p>
            </div>
          </div>
        </div>

        {/* 模拟的搜索界面 */}
        <div className="bg-gray-50 rounded-lg p-8 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">搜索功能演示</h2>
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <input
                type="text"
                placeholder="输入搜索关键词..."
                className="input flex-1"
              />
              <button className="btn btn-primary">搜索</button>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <p className="text-sm text-gray-600">
                搜索结果会这里显示，包括相关的记忆和建议。
              </p>
            </div>
          </div>
        </div>

        {/* 模拟的添加记忆界面 */}
        <div className="bg-gray-50 rounded-lg p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">添加新记忆</h2>
          <div className="space-y-4">
            <textarea
              placeholder="在这里输入你的记忆..."
              className="input min-h-[120px] resize-y"
            />
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <label className="text-sm text-gray-600">标签:</label>
                <input
                  type="text"
                  placeholder="学习, 工作, 灵感"
                  className="input w-48"
                />
              </div>
              <button className="btn btn-primary">保存</button>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            这只是一个简单的演示。实陆的 MemPalace 会更加智能和直观。
          </p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
